import { render } from "./UserAvatar.vue?vue&type=template&id=37b0c14a"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=37b0c14a&lang=sass"
script.render = render

export default script